<template>
  <div></div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data () {
    return {
    }
  },
  created () {
    let router = this.$router
    window.addEventListener('load', function () {
      window.cookieconsent.initialise({
        'palette': {
          'popup': {
            'background': '#252e39'
          },
          'button': {
            'background': '#14a7d0'
          }
        },
        'theme': 'classic',
        'content': {
          // 'message': 'За да випредоставим възможно най-доброто потребителско изживяване, ние използваме "бисквитки" на нашия сайт. Ако продължите, без да промените настройките си, ние ще приемем, че сте съгласни с употребата на "бисквитки" на този сайт. Вие можете да промените  настройките си за „бисквитки“ по всяко време.',
          'message': 'Здравейте! Уебсайтът ни, както много други, използва бисквитки, за да ви предоставим  адекватна информация <br> и удобство на работа.',
          'dismiss': 'Приемам',
          'link': 'Научете повече',
          'href': '/cookie-policy'
          // ':href': '$_config.BASE_URL/cookie-policy'
          // 'href': 'https://cookiesandyou.com/'
        },
        onPopupOpen: () => {
          // document.querySelector('#cookieconsent\\:desc').style.marginRight = '25px'
          let link = document.querySelector('a.cc-link')
          link.removeAttribute('target')
          link.onclick = (e) => {
            e.preventDefault()
            router.push('/cookie-policy')
          }
          //
          var button = document.getElementsByClassName('cc-btn cc-dismiss')[0]
          button.addEventListener('click', function () {
            /* eslint-disable */
            // window['ga-disable-UA-17199890-1'] = true;

            // (function (i, s, o, g, r, a, m) {
            //   i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
            //     (i[r].q = i[r].q || []).push(arguments)
            //   }, i[r].l = 1 * new Date(); a = s.createElement(o),
            //     m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
            // })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga')

            var loadCookiesOnConsent = function () {
              ga('create', 'UA-17199890-1', 'auto')
              ga('send', 'pageview')
            }

            loadCookiesOnConsent()
            /* eslint-enable */
          })

          var ccCompliance = document.getElementsByClassName('cc-compliance')[0]
          var spanDoNotAccept = document.createElement('span')
          spanDoNotAccept.style.marginRight = '15px'
          spanDoNotAccept.style.cursor = 'pointer'
          spanDoNotAccept.innerHTML = 'Не съм съгласен'
          spanDoNotAccept.addEventListener('click', function () {
            var ccWindow = document.getElementsByClassName('cc-window')[0]
            ccWindow.style.display = 'none'
          })
          ccCompliance.prepend(spanDoNotAccept)
        }
      })
    })
  }
}
</script>

<style lang='stylus' scoped>
@import '//cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.0.3/cookieconsent.min.css';

.margin-left-20 {
  padding-right: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CookieConsent.vue